import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import React, { useCallback, useContext } from 'react'
import { EditUserTypeRel } from 'modules/Rest'
import { MessageContext } from './Contexts'
import ActionButtons from './ActionButtons'
import { setModes } from 'modules/Utils'

export function PhoneNumberDialog({ user, userTypeKey, phoneNumber, setPhoneNumber, mode, setMode, callback }) {
  const { messageDispatch } = useContext(MessageContext)

  const savePhoneNumber = useCallback(async (e, setMode) => {
    try {
      setMode('pending')
      const { data: { success, info } } = await EditUserTypeRel({
        user_type: userTypeKey,
        user: user.user,
        two_factor_phone_number: phoneNumber,
      })
      if (success) {
        callback({ ...user, two_factor_phone_number: phoneNumber }, true)
        setModes(setMode, ['completing', 1500, ''])
      } else {
        throw new Error(info ? info : 'An error occurred')
      }
    } catch (error) {
      setMode('')
      messageDispatch({ type: 'warning', payload: error.message })
    }
  }, [user, userTypeKey, phoneNumber, messageDispatch, callback])

  return <Dialog open={mode !== ''} aria-labelledby='add-dialog' disableRestoreFocus>
    <DialogTitle>Edit two-factor phone number</DialogTitle>
    <DialogContent>
      <TextField
        value={phoneNumber}
        onChange={({ target: { value } }) => setPhoneNumber(value)}
        onKeyPress={({key}) => key === 'Enter' && savePhoneNumber(null, setMode)}
        autoFocus
        margin='dense'
        label='Phone number'
        type='text'
        fullWidth
        variant='standard'
      />
    </DialogContent>

    <DialogActions>
      <ActionButtons
        mode={mode}
        setMode={setMode}
        action={savePhoneNumber}
        cancel={(e, setMode) => setMode('')}
        actionTitle='Save'
        neverShowEdit={true}
      />
    </DialogActions>
  </Dialog>
}
